(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/banner-grid-item/views/header-image-bg.js') >= 0) return;  svs.modules.push('/components/lb-ui/banner-grid-item/views/header-image-bg.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lb_ui=_svs.lb_ui||{};
_svs.lb_ui.banner_grid_item=_svs.lb_ui.banner_grid_item||{};
_svs.lb_ui.banner_grid_item.templates=_svs.lb_ui.banner_grid_item.templates||{};
svs.lb_ui.banner_grid_item.templates.header_image_bg = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"banner-grid-item-header-image\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-content-image_v2-image"),(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"components-content-image_v2-image","hash":{"fitWrapper":"true"},"data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "  </div>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['components-lb_ui-banner_grid_item-header_image_bg'] = svs.lb_ui.banner_grid_item.templates.header_image_bg;
})(svs, Handlebars);


 })(window);